/*global _ */
import {
  APIURI, client_secret, client_id,
  axios, getFirstErrorMessage, getErrorMessage, getErrorMessages, getErrorMessagesWithKeys,
  handlePromise, promise, setPromise, getEndpoint,
  apiEndpoints, services,
} from './main'

const getPlayCardDetails = async (payload, options = {}) => {
  const endPoint = getEndpoint(options, _.get(apiEndpoints, 'playcard.details', '/customer/playcard/details'))
  const {data} = await axios.post(endPoint, payload)
  data.type = 'playcard'
  return data
}
setPromise('card.playcard.get', getPlayCardDetails)

const checkGiftCard = async (payload, options = {}) => {
  const endPoint = getEndpoint(options, _.get(apiEndpoints, 'giftcard.check', '/customer/giftcard/check'))
  const {data} = await axios.post(endPoint, payload)
  data.type = 'giftcard'
  return data
}
setPromise('card.giftcard.check', checkGiftCard)

const getCard = async (payload, options = {}) => {
  if (options.type === 'giftcard') {
    return await checkGiftCard(payload, options)
  }
  if (options.type === 'playcard') {
    return await getPlayCardDetails(payload, options)
  }
  let data = {}
  try {
    data = await getPlayCardDetails(payload, options)
    return data
  } catch (e) {
  }
  data = await checkGiftCard(payload, options)
  return data
}

setPromise('card.get', getCard)

const myServices = {getCard, getPlayCardDetails, checkGiftCard}

export {
  handlePromise, promise, setPromise, getEndpoint,
  apiEndpoints, services,
}

export default {
  handlePromise, promise, setPromise, getEndpoint,
  apiEndpoints, services,
  ...myServices
}
